<template>
  <v-container ma-0 pa-0 pr-3 fluid v-resize="resize">
    <v-navigation-drawer v-model="drawer" fixed app clipped right disable-resize-watcher disable-route-watcher>
      <v-card>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template #activator="{on}">
              <v-btn flat color="success" icon @click.stop="drawer = !drawer" v-on="on">
                <v-icon>close</v-icon>
              </v-btn>
            </template>
            <span>关闭</span>
          </v-tooltip>
        </v-card-actions>
        <v-card-title primary-title class="title">
          请选择要隐藏的字段
        </v-card-title>
        <v-container grid-list-xs fluid full-width>
          <v-layout row wrap align-center>
            <v-flex xs6 v-for="(item, index) in innerHeaders" :key="index">
              <v-switch color="error" :label="item.text" v-model="item.hide">
              </v-switch>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-navigation-drawer>
    <v-card-title ref="title" class="white" style="margin: 0px;padding: 0 10px;">
      <v-layout row wrap align-center>
        <slot name="query_condition">
        </slot>

        <v-spacer></v-spacer>

        <slot name="toolbar">

        </slot>
        <v-tooltip bottom open-delay="0" :fixed="false" :lazy="true" :close-delay="0">
          <template slot="activator">
            <v-btn icon flat @click.stop="fetchLayoutData">
              <v-icon>mdi-card-bulleted-settings-outline</v-icon>
            </v-btn>
          </template>
          <span>刷新布局</span>
        </v-tooltip>
        <v-tooltip bottom open-delay="0" :fixed="false" :lazy="true" :close-delay="0">
          <template slot="activator">
            <v-btn icon flat @click="drawer = !drawer">
              <v-icon>mdi-account-check-outline</v-icon>
            </v-btn>
          </template>
          <span>自定义显示字段</span>
        </v-tooltip>
        <v-tooltip bottom open-delay="0" :fixed="false" :lazy="true" :close-delay="0">
          <template slot="activator">
            <v-btn icon flat @click="navigateToConfig()">
              <v-icon>mdi-ballot-recount-outline</v-icon>
            </v-btn>
          </template>
          <span>表格配置</span>
        </v-tooltip>
      </v-layout>
    </v-card-title>
    <div ref="div" class="white">
      <v-data-table ref="table" v-model="selectedItmes" :rows-per-page-items="rowsPerPageItems" :headers="Headers"
        :items="items" :hide-actions="hideActions" class="elevation-1 fixed-header v-table__overflow" :style="{maxHeight: maxHeight,backfaceVisibility:
      'hidden'}" :select-all="selectAll" :pagination.sync="innerPagination" :must-sort="mustSort"
        :total-items="totalItems" :light="light" :dark="light" :hide-headers="hideHeaders"
        :headers-length="headersLength" :header-key="headerKey" :header-text="headerText" :filter="filter"
        :expand="expand" :disable-initial-sort="disableInitialSort" :custom-sort="customSort"
        :custom-filter="customFilter" :item-key="itemKey" :loading="loading" :search="search" @input="input"
        @update:pagination="updatePagination">
        <template #actions-append>
          <slot name="actions-append"></slot>
        </template>
        <template #actions-prepend>
          <slot name="actions-prepend"></slot>
        </template>
        <template #footer>
          <slot name="footer"></slot>
        </template>
        <template #no-data>
          <slot name="no-data"></slot>
        </template>
        <template #no-results>
          <slot name="no-results"></slot>
        </template>
        <template #header-cell="{header}">
          <slot name=" header-cell" :header="header"></slot>
        </template>

        <template #page-text="{ pageStart, pageStop, itemsLength}">
          <slot name="page-text" :pageStart="pageStart" :pageStop="pageStop" :itemsLength="itemsLength"></slot>
        </template>
        <template #items="props">
          <slot :headers="innerHeaders" :props="props">
            <data-row :headers="innerHeaders" :props="props" :before-intial="beforeIntial">
              <template v-slot:[getCellSlotName(header)]="{props,header}" v-for="header in innerHeaders">
                <slot :name="getCellSlotName(header)" :props="props" :header="header"></slot>
              </template>
            </data-row>
          </slot>
        </template>
      </v-data-table>
    </div>
  </v-container>
</template>

<style>
  .theme--dark.v-table thead th {
    background-color: #424242;
  }

  .theme--light.v-table thead th {
    background-color: #fff;
  }

  /* Theme */
  .fixed-header {
    display: flex;
    flex-direction: column;
    height: 100%;
  }



  .fixed-header table {
    table-layout: fixed;
  }

  .fixed-header th {
    position: sticky;
    top: 0;
    z-index: 1;
  }

  .fixed-header th:after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
  }

  .fixed-header tr.v-datatable__progress th {
    height: 1px;
  }

  .fixed-header .v-table__overflow {
    flex-grow: 1;
    flex-shrink: 1;
    overflow-x: auto;
    overflow-y: auto;
  }

  .fixed-header .v-datatable.v-table {
    flex-grow: 0;
    flex-shrink: 1;
  }

  .fixed-header .v-datatable.v-table .v-datatable__actions {
    flex-wrap: wrap;
  }

  .fixed-header .v-datatable.v-table .v-datatable__actions .v-datatable__actions__pagination {
    white-space: wrap;
  }

  table.v-table tbody td:not(:first-child),
  table.v-table tbody th:not(:first-child),
  table.v-table thead td:not(:first-child),
  table.v-table thead th:not(:first-child) {
    padding: 0 8px;
    flex-wrap: wrap;
  }


  table.v-table thead th:first-child,
  table.v-table thead td:first-child,
  table.v-table tbody td:first-child,
  table.v-table tbody th:first-child {
    padding: 0 24px;
    width: 60px;

  }
</style>

<script>
  import DataTable from "./dataTable.ts";
  export default DataTable;
</script>